export default __webpack_public_path__ + "static/media/video_off.f14e273c.svg";